/**
 * Handle smooth scroll.
 *
 */

$(document).on("click", ".js-arrow", function (e) {
  e.preventDefault();

  $("html, body").animate(
    {
      scrollTop: 0,
    },
    300
  );
});

$(window).bind("touchmove", function (e) {
  e.preventDefault();
});
